export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f99d71e5147af08f95a30af59101afda21cdcb7b3&name=fetchTypeahead!'